import { RootState } from 'editor/src/store/index';

import getNextStates from './getNextStates';

const getNextStatesCount = (state: RootState) => getNextStates(state).length;

export default getNextStatesCount;
